import React,{Component} from 'react';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  FormText
} from 'reactstrap';

import Form from '../../../shared/components/Form';
import Button from '../../../shared/components/Button';
import HiddenInput from '../../../shared/components/HiddenInput';
import TextInput from '../../../shared/components/TextInput';
import DroppableFileInput from '../../../shared/components/DroppableFileInput';
import ColorInput from '../../../shared/components/ColorInput';

import { divideArrayIntoNGroups } from '../../../shared/utils';

class BrandInfo extends Component {
  constructor(){
    super();

    this.state = {
      color:null,
      logo:null,
      areAgenciesLoaded:false,
      isUpdating:false,
      retailersLoaded:false,
      validationMessages:{}
    };
  }

  componentWillMount(){
    if(this.props.logoURL && this.props.logoFileName){
      this.setState({logo:{
        fileName:this.props.logoFileName,
        large:this.props.logoURL
      }});
    }
  }

  componentDidMount(){
    const {isCreate,accountId,loadAgencies,loadRetailers} = this.props;

    if(isCreate && !accountId){
      loadAgencies()
        .then(() => this.setState({areAgenciesLoaded:true}))
        .catch((err) => this.handleError(err));
    }
  }

  handleSubmit(data){

    const { createBrand, isCreate,updateBrand,setRetailersForBrand,brandId } = this.props;

    const { logo } = this.state;

    const selectedRetailerIds = Object.keys(data.retailers || {}),
      allRetailerIds = this.props.retailers.map((r) => r.id),
      allRetailers = data.allRetailers && data.allRetailers === 'on',
      approvedRetailerIds = allRetailers ? allRetailerIds : selectedRetailerIds;

    const validationMessages = {};

    delete data.allRetailers;
    delete data.retailers;


    if(!data.name || data.name.length === 0){
      validationMessages['name'] = 'Name is required';
    }

    if(!data.primaryColor || data.primaryColor.length === 0){
      validationMessages['primaryColor'] = 'Primary color is required';
    }

    if(!logo || (logo && !logo.fileName)){
      validationMessages['logo'] = 'Logo is required';
    }

    if(approvedRetailerIds.length > 0){
      data.approvedRetailers = approvedRetailerIds
    }

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
      return;
    } else if(isCreate){
      this.setState({isUpdating:true});
      createBrand({
        ...data,
        isBrand:true,
        logoId:logo.id,
        logoFileName:logo.fileName,
        logoURL:logo.large
      })
        .then((res) => this.handleCreateSuccess(res))
        .catch((err) => this.handleError(err));

      return;
    } else {
      this.setState({isUpdating:true});
      Promise.all([
        updateBrand(brandId,{
          ...data,
          isBrand:true,
          logoId:logo.id,
          logoFileName:logo.fileName,
          logoURL:logo.large
        })
      ])
        .then(() => this.handleUpdateSuccess())
        .catch((err) => this.handleError(err))
    }

    return;
  }

  handleCreateSuccess(res){
    const { history, accountId, loadBrand } = this.props;

    this.setState({isUpdating:false});

    if(accountId){
      history.push(`/superadmin/accounts/${accountId}/brands`);
    } else {
      window.setTimeout(() => {
        loadBrand(res.instance.id)
          .then( () => history.push(`/superadmin/brands/${res.instance.id}/edit`))
      },2000);
    }
  }

  handleLogoChange(logo){
    this.setState({
      logo:logo,
      logoId:logo.id,
      logoFileName:logo.fileName,
      logoThumbnailURL:logo.thumbnail,
      logoURL:logo.large
    });
  }

  handleUpdateSuccess(){
    this.setState({isUpdating:false});
  }

  handleError(err){}

  getSubmitButtonText(){
    const { isCreate } = this.props;
    const { isUpdating } = this.state;

    if(isCreate && !isUpdating) return 'Create Brand';
    if(isCreate && isUpdating) return 'Creating Brand';
    if(!isCreate && !isUpdating) return 'Update Brand';
    if(!isCreate && isUpdating) return 'Updating Brand';

    return 'Create Brand';
  }

  render(){
    const {
      isCreate,
      name,
      logoURL,
      logoFileName,
      primaryColor,
      accountId,
      agencies,
      retailers,
      currentApprovedRetailers
    } = this.props;

    const {
      retailersLoaded,
      validationMessages
    } = this.state;

    return (
      <div>
        <Form onSubmit={(data) => this.handleSubmit(data)}>
          <Row>
            <Col xs='12' md='8'>
              {isCreate && (
                <div>
                  <br />
                  <h3>New Brand</h3>
                  <br />
                </div>
              )}
              <TextInput 
                label='Name'
                name='name'
                maxLength={40}
                placeholder='Acme inc'
                defaultValue={name}
                warning={validationMessages['name']}
              />
              {accountId && ( <HiddenInput name='agencyId' value={accountId} /> )}
              {isCreate && !accountId && (
                <FormGroup>
                  <Label>Account</Label>
                  <Input
                    type='select'
                    name='agencyId'
                  >
                    {agencies.map((a) => (
                      <option key={a.id} value={a.id}>
                        {a.name}
                      </option>
                    ))}
                  </Input>
                  {validationMessages['agencyId'] && (
                    <FormText className='DangerFeedback'>
                      {validationMessages['agencyId']}
                    </FormText>
                  )}
                </FormGroup>
              )}
              <DroppableFileInput 
                label='Logo'
                fileType='image'
                name='logo'
                text='Upload logo'
                existingFileName={logoFileName}
                existingFileURL={logoURL}
                warning={validationMessages['logo']}
                cropperAspectRatio={1/1}
                onChange={(logo) => this.setState({logo:logo})}
              />
              <ColorInput 
                label='Primary Color'
                name='primaryColor' 
                defaultValue={primaryColor} 
                warning={validationMessages['primaryColor']}
              />
            </Col>
          </Row>
          <Row>
            <Col xs='12'>
              <br />
              <Button isSubmit>
                {this.getSubmitButtonText()}
              </Button>
              <br />
              <br />
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}

BrandInfo.defaultProps = {
  isCreate:false
};

export default BrandInfo;



// WEBPACK FOOTER //
// ./src/routes/BrandInfo/components/BrandInfo.js